"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgColor = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const FormRow_1 = require("../../../../3-list-item/FormRow");
const css_1 = require("./css");
const InputColor_1 = require("../../../../2-inline-block/InputColor");
const ArgColorCompact_1 = require("./ArgColorCompact");
const unwrapColor = (v) => {
    if (v && typeof v === 'object' && 'value' in v)
        return String(v.value ?? '');
    return v ?? '';
};
const ArgColor = (props) => {
    if (props.compact)
        return React.createElement(ArgColorCompact_1.ArgColorCompact, { ...props });
    const { param, compact: _compact, value, onChange, ...rest } = props;
    return (React.createElement("div", { className: css_1.argBlockCss },
        React.createElement(FormRow_1.FormRow, { title: param.display?.() ?? param.name ?? param.id, optional: param.optional },
            React.createElement(InputColor_1.InputColor, { ...rest, value: unwrapColor(value), onChange: onChange, placeholder: '#hex' }))));
};
exports.ArgColor = ArgColor;
